// src/app/state/app-state.utils.ts

import { AppState } from './app-state.model';

const STORAGE_KEY = 'APP_GLOBAL_STATE';

export function loadState(): AppState | null {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? (JSON.parse(data) as AppState) : null;
}

export function saveState(state: AppState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}
